import { styled, Stack, Box } from '../../../base';

export const StyledSourceOfHireWrapper = styled(Stack)({
    flex: 1,
    height: '100%',
});

export const StyledFilterRow = styled(Box)({
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
});

export const StyledFilterSlot = styled(Box)({
    flex: 1,
    minWidth: 0,
});

export const StyledViewToggleSlot = styled(Box)(({ theme }) => ({
    flexShrink: 0,
    paddingInlineEnd: theme.spacing(3),
}));
